import {each} from 'lodash';

export default class RangeLiveValue {

    static init() {
        each(document.querySelectorAll('input[type="range"]'), (range) => {
            if (! $(range).data('liveValue')) {
                return false;
            }
            range.addEventListener('input', () => {
                if (range.value === range.getAttribute('max') || range.value === range.getAttribute('min')) {
                    document.querySelector(range.dataset['target']).textContent = '';
                } else {
                    document.querySelector(range.dataset['target']).textContent = range.value + 'km';
                }
            });
        });
    }
}
